// extracted by mini-css-extract-plugin
export default {"landscapeBasicInformationAddTemplateWrapper":"LandscapeBasicInformationAddPage_landscapeBasicInformationAddTemplateWrapper__Oshu8"};